<template>
   <!-- 添加家庭成员的对话框 -->
    <div class="studyModal">
      <a-modal
       :title="biaoji ? '修改家庭成员信息' : '新增家庭成员信息'"
       :visible="showVisible"
       okText="下一步"
       :footer="null"
       @cancel="cancel"
       :dialogStyle="dialogStyle"
      >



   
          <a-form-model ref="jtRef" :rules="jtRule" :model="formFM" :label-col="labelCol" :wrapper-col="wrapperCol">

            <a-row>
             <a-col :span="12" :offset="1">
              <a-form-model-item label="姓名" prop="a1501">
                <a-input :maxLength="20" v-model="formFM.a1501" style="width: 180px"></a-input>
              </a-form-model-item>
             </a-col>

              <a-col :span="11">
                <a-form-model-item label="与本人关系" prop="a1503">
                 <a-select allowClear  v-model="formFM.a1503" style="width: 180px">
                <a-select-option v-for="(item,i) in relation" :key="i" :label="item.DMCOD" :value="item.DMCOD">{{item.DMCPT}}</a-select-option>
                  </a-select>
                </a-form-model-item>
              </a-col>
            </a-row>

            <a-row>
             <a-col :span="12" :offset="1">
              <a-form-model-item label="民族" prop="a1506">
              <a-select allowClear  v-model="formFM.a1506" style="width: 180px">
                <a-select-option v-for="(item,i) in nations" :key="i" :label="item.DMCOD" :value="item.DMCOD">{{item.DMCPT}}</a-select-option>
              </a-select>
              </a-form-model-item>
             </a-col>

              <a-col :span="11">
                <a-form-model-item label="政治面貌" prop="a1504">
                <a-select allowClear  v-model="formFM.a1504" style="width: 180px">
                <a-select-option v-for="(item,i) in Political" :key="i" :label="item.DMCOD" :value="item.DMCOD">{{item.DMCPT}}</a-select-option>
                </a-select>
                </a-form-model-item>
              </a-col>
            </a-row>

            <a-row>
             <a-col :span="12" :offset="1">
              <a-form-model-item label="出生日期" prop="a1507">
              <a-date-picker :inputReadOnly="true" placeholder="出生日期" show-tiem type="date"  v-model="formFM.a1507" style="width: 180px"></a-date-picker>
              </a-form-model-item>
             </a-col>

              <a-col :span="11">
                <a-form-model-item label="联系电话" prop="a1508">
                <a-input :maxLength="20" type="number" v-model="formFM.a1508" style="width: 180px">
                </a-input>
                </a-form-model-item>
              </a-col>
            </a-row>

          <div class="txtarea">
            <a-row>
              <a-col :span="15">
                <a-form-model-item label="工作单位及职务" prop="a1505">
                <a-input :maxLength="300" :auto-size="{ minRows: 5, maxRows: 6 }" type="textarea" :cols="20" :rows="5" placeholder="若无职位，职务可不填写" v-model="formFM.a1505"></a-input>
                </a-form-model-item>
              </a-col>
            </a-row>
          </div>

          </a-form-model>

       <div class="dialogFooter">
        <!-- 保存 -->
        <button class="btnStyle1" @click="addFamilyNumber" v-show="!biaoji">保存</button>
         <!-- 修改 -->
        <button class="btnStyle1" @click="updateFamilyNumber" v-show="biaoji">保存</button>
        <!-- 取消 -->
        <button class="btnStyle1" @click="cancel">取消</button>
      </div>


      </a-modal>
    </div>
</template>


<script>
import moment from 'moment'
export default {
  props:{
    FMVisible:{
      type:Boolean,
      require:true
    },
    FMInfo:{
      type:Object,
      require:true
    },
    FamilyListDate:{
      type:Array
    }
  },

  data(){
    //移动电话
    let validateYddh = (rule, value, callback) => {
      var reg = /^(13[0-9]|14[5|7]|15[0|1|2|3|5|6|7|8|9]|18[0|1|2|3|5|6|7|8|9]|17[0|1|2|3|5|6|7|8|9])\d{8}$/;
      if (!reg.test(value)) {
        callback(new Error('移动电话格式错误'));
      }else{
        callback();
      }
    }
    
    //不能为负数
    let validatefs = (rule, value, callback) => {
      var reg =   /^\+?((0|([1-9]+\d*))|((0\.\d+)|([1-9]+\d*\.\d+)))$/;
      if (!reg.test(value)) {
        callback(new Error('不能够为负数'));
      }else{
        callback();
      }
    }
    return{
       labelCol: { span: 9 },
      wrapperCol: { span: 10 },

      showVisible:false,

      biaoji:null,

       //家庭成员表单数据
      formFM:{},

      //下拉框数据
      //家庭成员关系
      relation:[],
       //民族
      nations: [], 
      //政治面貌
      Political:[],
      
      dialogStyle: {
        right:"100px"
      },


      //校验规则
      jtRule:{
        a1501: [
          { required: true, message: '请输入名称', trigger: 'blur' },
        ],
        a1503: [
          { required: true, message: '请输入与本人关系', trigger: 'blur' },
        ],
        a1506: [
          { required: true, message: '请输入民族', trigger: 'blur' },
        ],
        a1504: [
        ],
        a1507: [
          { required: true, message: '请输入出生日期', trigger: 'change' },
        ],
        a1508: [
          { required: true, message: '请输入联系电话', trigger: 'blur' },
          { validator: validateYddh, trigger: 'blur' },
        ],
        a1505: [
        ],
      }
    }
  },

  mounted(){
    this.showVisible=this.FMVisible
  },

  watch:{
    FMVisible(){
      this.getxl()
      this.getmz()
      this.getzzmm()
      this.showVisible=this.FMVisible
    },
    FMInfo(){
      this.formFM=this.FMInfo
      this.biaoji=this.FMInfo.biaoji
    }
  },


  methods:{
    cancel(){
      this.$refs.jtRef.resetFields()
      this.showVisible=false
      this.$emit('update:FMVisible',false)
      this.$emit('updt')
    },
    
    //添加
    addFamilyNumber(){
      //填写的是丈夫
      let ifreturn = false
      if(this.formFM.a1503 === '11'){
        //判断丈夫是否填写过
        this.FamilyListDate.forEach((item) => {
          if(item.a1503 === "丈夫"){
            this.$message.warning('您已经添加过丈夫了')
            ifreturn = true
          }
        })
      }
      if(this.formFM.a1503 === "12"){
        //判断妻子是否填写过
        this.FamilyListDate.forEach((item) => {
          if(item.a1503 === "妻子"){
            this.$message.warning('您已经添加过妻子了')
            ifreturn = true
          }
        })
      }
      if(ifreturn){
        return
      }
      console.log(this.formFM)
      console.log(this.FamilyListDate)

       this.$refs.jtRef.validate(valid => {
        if(!valid) return this.$message.warning('请完成表单内容')
      
       if(!typeof(this.formFM.a1503*0)!=='number'){
        this.relation.map(i=>{
        if(i.DMCPT==this.formFM.a1503){
            this.formFM.a1503= i.DMCOD
        }
      })
      }else{
        // this.relation.a0104*0+1
      }

      if(!typeof(this.formFM.a1506*0)!=='number'){
        this.nations.map(i=>{
        if(i.DMCPT==this.formFM.a1506){
            this.formFM.a1506= i.DMCOD
        }
      })
      }else{
        // this.nations.a0104*0+1
      }

      if(!typeof(this.formFM.a1504*0)!=='number'){
        this.Political.map(i=>{
        if(i.DMCPT==this.formFM.a1504){
            this.formFM.a1504= i.DMCOD
        }
      })
      }else{
        // this.Political.a0104*0+1
      }

      //格式化时间
       if((this.formFM.a1507).unix()*1000>new Date().getTime()) return this.$message.warning('出生日期不能晚于当前时间');
      this.formFM.a1507=moment(this.formFM.a1507).format('YYYY-MM-DD');

      this.formFM.a00=sessionStorage.getItem('aabb')
      this.post({
        url:'addFamilyNumber',
        data:this.formFM
      },(res)=>{
        console.log(this.formFM);
        console.log(res);
        if(res.message === '新增成功'){
          this.$message.success('添加家庭新成员成功')
          this.$emit('updt')
          this.cancel()
        }else{
          this.$message.warning(res.message)
          this.$emit('updt')
          this.cancel()
        }

      })
       })
    },

    //修改
    updateFamilyNumber(){
      let ifreturn = false
      //填写的是丈夫
      if(this.formFM.a1503 === '11'){
        //判断丈夫是否填写过
        this.FamilyListDate.forEach((item) => {
          if(item.a1503 === "丈夫"){
            this.$message.warning('您已经添加过丈夫了')
            ifreturn = true
          }
        })
      }
      if(this.formFM.a1503 === "12"){
        //判断妻子是否填写过
        this.FamilyListDate.forEach((item) => {
          if(item.a1503 === "妻子"){
            this.$message.warning('您已经添加过妻子了')
            ifreturn = true
          }
        })
      }
      if(ifreturn){
        return
      }
       // 格式化日期的函数
       function getTargetTime(t){
        var d = t.split(" ")[0],
        h = t.split(" ")[1],
        date = new Date()

        date.setYear(d.split("-")[0])
        date.setMonth(d.split("-")[1] - 1)
        date.setDate(d.split("-")[2])

    
        return date.getTime()    
      }

      this.$refs.jtRef.validate(valid => {
        if(!valid) return this.$message.warning('请完成表单内容')
      //此处修改下拉框数据 为真实值
      if(!typeof(this.formFM.a1503*0)!=='number'){
        this.relation.map(i=>{
        if(i.DMCPT==this.formFM.a1503){
            this.formFM.a1503= i.DMCOD
        }
      })
      }else{
        // this.relation.a0104*0+1
      }

      if(!typeof(this.formFM.a1506*0)!=='number'){
        this.nations.map(i=>{
        if(i.DMCPT==this.formFM.a1506){
            this.formFM.a1506= i.DMCOD
        }
      })
      }else{
        // this.nations.a0104*0+1
      }

      if(!typeof(this.formFM.a1504*0)!=='number'){
        this.Political.map(i=>{
        if(i.DMCPT==this.formFM.a1504){
            this.formFM.a1504= i.DMCOD
        }
      })
      }else{
        // this.Political.a0104*0+1
      }

      //格式化时间
      if(typeof(this.formFM.a1507)=='string'){
        if(getTargetTime(this.formFM.a1507)>new Date().getTime()) return this.$message.warning('出生日期不能晚于当前时间');
      }else{
       if((this.formFM.a1507).unix()*1000>new Date().getTime()) return this.$message.warning('出生日期不能晚于当前时间');
      }
      this.formFM.a1507=moment(this.formFM.a1507).format('YYYY-MM-DD');
        console.log(this.formFM);
      this.post({
        url:'updateFamilyNumber',
        data:this.formFM
      },(res)=>{
        console.log(98789);
        console.log(this.formFM);
        if(res.code==200){
          if(res.message === '更新成功'){
            this.$message.success('修改家庭新成员成功')
            this.$emit('updt')
            this.cancel()
          }else{
            this.$message.warning(res.message)
            this.$emit('updt')
            this.cancel()
          }
        }  
      })
      })
    },
   

      //获取下拉框数据
     //与本人关系
    getxl(){
      this.get({
        url:'getCodeTableAndKeyWordAllItem',
        data:{
          codeTableName:'GB4761'
        }
      },(res)=>{
        if(res.code==200){
          this.relation=res.data
        }
      })
    },

     //民族
    getmz(){
      this.get({
        url:'getCodeTableAndKeyWordAllItem',
        data:{
          codeTableName:'GB3304'
        }
      },(res)=>{
        if(res.code==200){
          this.nations=res.data
        }
      })
    },

     //政治面貌
    getzzmm(){
      this.get({
        url:'getCodeTableAndKeyWordAllItem',
        data:{
          codeTableName:'GB4762'
        }
      },(res)=>{
        if(res.code=200){
          this.Political=res.data
        }
      })
    },


    getBit (value, bit) {
      let str = Number(value);
      str = str.toFixed(bit)
      console.log(str)
      return str;
  },

  //禁止输入负数
  proving2(e) {
            console.log(e.target.value)
            console.log(this.getBit(e.target.value,1))
            var keynum = window.event ? e.keyCode : e.which;   //获取键盘码
            var keychar = String.fromCharCode(keynum);  //获取键盘码对应的字符
            if (keynum ==189||keynum == 109) { //禁止输入负数
              this.$message.warning('禁止输入负数')
              e.target.value = 0
            }
  },
  },
  

  created(){
    
  }
}
</script>




<style scoped>


.dialogFooter{
  background-color: #e3efff;
  border: 1px solid #c1d7f9;
  display: flex;
  justify-content: center;
  align-items: center;
}

.btnStyle1{
  width: 84px;
  height: 36px;
  background-color: #f1a338;
  font-size: 16px;
  line-height: 36px;
  text-align: center;
  color: #fff;
  border: none;
  border-radius: 3px;
  margin: 10px 5px;
}

.btnStyle1:hover{
  cursor:pointer;
}






/deep/ .ant-modal-content{
  width: 696px!important;
  height: 520px!important;
}


/deep/ .txtarea .ant-form-item-control{
  width: 490px!important;
}

input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
     -webkit-appearance: none;
}

input[type="number"] {
      -moz-appearance: textfield;
}


</style>


// WEBPACK FOOTER //
// src/views/zkzw/compos/jtcy.vue